import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/arrow-left.svg'


const _hoisted_1 = {
  key: 0,
  class: "loader-block-info",
  role: "alert",
  title: "Data is loading"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner",
  id: "loading-bar-spinner"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "spinner-icon" })
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  href: "javascript:void(0)",
  class: "back-btn"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Back Button"
}, null, -1)
const _hoisted_6 = {
  key: 2,
  class: "site-section",
  role: "main"
}
const _hoisted_7 = { class: "profile-section" }
const _hoisted_8 = { class: "entity-detail-section" }
const _hoisted_9 = { class: "categories-block" }
const _hoisted_10 = { class: "entity-title sub-entity-title entity-category-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SidePanelHeader = _resolveComponent("SidePanelHeader")!
  const _component_DatasetFilterWarning = _resolveComponent("DatasetFilterWarning")!
  const _component_EntityBanner = _resolveComponent("EntityBanner")!
  const _component_EntityDetailsDropdown = _resolveComponent("EntityDetailsDropdown")!
  const _component_ViewMoreDetailsView = _resolveComponent("ViewMoreDetailsView")!
  const _component_ThirdLevelTimeline = _resolveComponent("ThirdLevelTimeline")!
  const _component_NoResults = _resolveComponent("NoResults")!
  const _component_CategorySelection = _resolveComponent("CategorySelection")!
  const _component_EntityViewSelector = _resolveComponent("EntityViewSelector")!
  const _component_EntityList = _resolveComponent("EntityList")!
  const _component_EntityTimeline = _resolveComponent("EntityTimeline")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_SidePanelHeader),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    (!_ctx.loading && !_ctx.viewMoreView)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "header-btn-block",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onBack && _ctx.onBack(...args))),
          role: "navigation"
        }, [
          _createElementVNode("a", _hoisted_4, [
            _hoisted_5,
            _createTextVNode(" " + _toDisplayString(_ctx.$t("EntityInfoView.back")), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.loading && !_ctx.viewMoreView)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_ctx.datasetsToHide.length > 0)
            ? (_openBlock(), _createBlock(_component_DatasetFilterWarning, {
                key: 0,
                initialSwitchValue: _ctx.disableDatasetFilters,
                onDatasetFilterUpdate: _cache[1] || (_cache[1] = (update) => { _ctx.disableDatasetFilters = update })
              }, null, 8, ["initialSwitchValue"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parsedEntityInfo, (entity, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "profile-section-profile"
              }, [
                _createVNode(_component_EntityBanner, {
                  firstEntity: index == 0,
                  entity: entity,
                  index: index,
                  parsedEntityInfo: _ctx.parsedEntityInfo,
                  showDetailsIndex: _ctx.showDetailsIndex,
                  annotationsView: _ctx.annotationsView
                }, null, 8, ["firstEntity", "entity", "index", "parsedEntityInfo", "showDetailsIndex", "annotationsView"]),
                (_ctx.showDetailsIndex === index)
                  ? (_openBlock(), _createBlock(_component_EntityDetailsDropdown, {
                      key: 0,
                      data: entity,
                      datasets: _ctx.datasets,
                      datasetsToDisplay: _ctx.datasetsToDisplay,
                      datasetsToHide: _ctx.datasetsToHide,
                      disableDatasetFilters: _ctx.disableDatasetFilters,
                      onUpdate: ($event: any) => {
                        _ctx.viewMoreView = true;
                        _ctx.viewMoreEntity = entity;
                    }
                    }, null, 8, ["data", "datasets", "datasetsToDisplay", "datasetsToHide", "disableDatasetFilters", "onUpdate"]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          (
                _ctx.parsedEntityInfo.length >= 3 ||
                (_ctx.annotationsView && _ctx.parsedEntityInfo.length == 2)
            )
            ? (_openBlock(), _createBlock(_component_ViewMoreDetailsView, {
                key: 1,
                data: _ctx.parsedEntityInfo[_ctx.parsedEntityInfo.length - 1],
                datasets: _ctx.datasets,
                datasetsToDisplay: _ctx.datasetsToDisplay,
                datasetsToHide: _ctx.datasetsToHide,
                isAnnotationView: _ctx.annotationsView,
                timelineState: _ctx.timelineState,
                disableDatasetFilters: _ctx.disableDatasetFilters,
                hideBackButton: "",
                isLastEntity: "",
                onDatasetFilterUpdate: _cache[2] || (_cache[2] = (update) => { _ctx.disableDatasetFilters = update })
              }, null, 8, ["data", "datasets", "datasetsToDisplay", "datasetsToHide", "isAnnotationView", "timelineState", "disableDatasetFilters"]))
            : _createCommentVNode("", true),
          (_ctx.parsedEntityInfo.length >= 3 && _ctx.parsedEntityInfo[_ctx.parsedEntityInfo.length - 2].connectedEntities.length > 1)
            ? (_openBlock(), _createBlock(_component_ThirdLevelTimeline, {
                key: 2,
                eventList: 
                _ctx.parsedEntityInfo[_ctx.parsedEntityInfo.length - 2].connectedEntities
            ,
                currentEvent: 
                _ctx.parsedEntityInfo[_ctx.parsedEntityInfo.length - 1].mainEntityInfo
            ,
                onUpdate: _cache[3] || (_cache[3] = (update) => {
                            if (!update) {
                                _ctx.parsedEntityInfo.pop();
                            } else {
                                _ctx.timelinePartial = true;
                            }
                        })
              }, null, 8, ["eventList", "currentEvent"]))
            : _createCommentVNode("", true),
          _withDirectives(_createVNode(_component_NoResults, { "full-length": "" }, null, 512), [
            [_vShow, _ctx.entitiesByCategory['All'].length == 0]
          ]),
          _withDirectives(_createVNode(_component_CategorySelection, {
            entityCategories: _ctx.annotationsView ? 
                _ctx.annotationCategories :
                Object.keys(_ctx.entitiesByCategory['Categories']),
            annotationsView: _ctx.annotationsView,
            onUpdate: _cache[4] || (_cache[4] = (aboutSubjectDisplaySelection) => { _ctx.aboutSubjectDisplay = aboutSubjectDisplaySelection })
          }, null, 8, ["entityCategories", "annotationsView"]), [
            [_vShow, _ctx.entitiesByCategory['All'].length > 0 && (_ctx.displayCategorySelection || (_ctx.annotationsView && _ctx.aboutSubjectDisplay == null))]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("h3", null, _toDisplayString(_ctx.connectedEntityTitle), 1),
                _withDirectives(_createVNode(_component_EntityViewSelector, {
                  onUpdate: _cache[5] || (_cache[5] = 
                            (update) => {
                                _ctx.timelineView =
                                    update.timelineView != null
                                        ? update.timelineView
                                        : _ctx.timelineView;
                                _ctx.listView =
                                    update.listView != null
                                        ? update.listView
                                        : _ctx.listView;
                            }
                        )
                }, null, 512), [
                  [_vShow, _ctx.uriList.length === 2]
                ])
              ]),
              _withDirectives(_createVNode(_component_EntityList, {
                onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.loading = true)),
                connectedEntityTitle: _ctx.connectedEntityTitle,
                categoryToDisplay: _ctx.categoryToDisplay,
                annotationsView: _ctx.annotationsView,
                aboutSubjectDisplay: _ctx.aboutSubjectDisplay ?? false,
                expandedEntityIndex: _ctx.expandedEntityIndex
              }, null, 8, ["connectedEntityTitle", "categoryToDisplay", "annotationsView", "aboutSubjectDisplay", "expandedEntityIndex"]), [
                [_vShow, _ctx.listView]
              ]),
              _withDirectives(_createVNode(_component_EntityTimeline, {
                categoryToDisplay: _ctx.categoryToDisplay,
                expandedEntityIndex: _ctx.expandedEntityIndex
              }, null, 8, ["categoryToDisplay", "expandedEntityIndex"]), [
                [_vShow, _ctx.timelineView]
              ])
            ])
          ], 512), [
            [_vShow, 
                _ctx.entitiesByCategory['All'].length > 0 &&
                (
                    (_ctx.annotationsView && _ctx.aboutSubjectDisplay != null && _ctx.parsedEntityInfo.length != 2) ||
                    (!_ctx.displayCategorySelection &&
                        !_ctx.viewMoreView &&
                        _ctx.parsedEntityInfo.length != 3 &&
                        !_ctx.annotationsView)
                )
            ]
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.viewMoreView)
      ? (_openBlock(), _createBlock(_component_ViewMoreDetailsView, {
          key: 3,
          data: _ctx.viewMoreEntity,
          datasets: _ctx.datasets,
          datasetsToDisplay: _ctx.datasetsToDisplay,
          datasetsToHide: _ctx.datasetsToHide,
          disableDatasetFilters: _ctx.disableDatasetFilters,
          onUpdate: _cache[7] || (_cache[7] = ($event: any) => (_ctx.viewMoreView = !_ctx.viewMoreEntity)),
          onDatasetFilterUpdate: _cache[8] || (_cache[8] = (update) => { _ctx.disableDatasetFilters = update })
        }, null, 8, ["data", "datasets", "datasetsToDisplay", "datasetsToHide", "disableDatasetFilters"]))
      : _createCommentVNode("", true)
  ], 64))
}